<template>
<div>
  <section class="self">
    <div class="container">
      <com-h1 title="联席主席"></com-h1>
      <com-speakers :speakers="speakers"></com-speakers>
    </div>
  </section>
</div>
</template>

<script>
import ComH1 from 'gkConUI/com-h1'
import ComSpeakers from 'gkConUI/com-speakers'

export default {
  components: {
    ComH1,
    ComSpeakers
  },
  props: ['speakers'],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"

.self
  // background-color: #f8f8f8
// .speakers
  // padding: 47px 0
  // background-color: $primary
</style>
